'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHoc = require('@mindz/react-hoc');

var _ActionsModule = require('./Actions.module.css');

var _ActionsModule2 = _interopRequireDefault(_ActionsModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var HomeIcon = function HomeIcon(props) {
  return _react2.default.createElement('svg', props, _react2.default.createElement('defs', null, _react2.default.createElement('path', {
    id: 'a',
    d: 'M0 0h30v30H0z'
  })), _react2.default.createElement('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, _react2.default.createElement('mask', {
    id: 'b',
    fill: '#fff'
  }, _react2.default.createElement('use', {
    xlinkHref: '#a'
  })), _react2.default.createElement('path', {
    fill: '#FF4056',
    d: 'M11 24v-9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v9h3a1 1 0 0 0 1-1V12.49l-8-6.223-8 6.222V23a1 1 0 0 0 1 1h3zm2 0h4v-8h-4v8zM5.386 11.21l9-7a1 1 0 0 1 1.228 0l9 7A1 1 0 0 1 25 12v11a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V12a1 1 0 0 1 .386-.79z',
    mask: 'url(#b)'
  })));
};

HomeIcon.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  width: '30',
  height: '30',
  viewBox: '0 0 30 30'
};

var RemoveIcon = function RemoveIcon(props) {
  return _react2.default.createElement('svg', props, _react2.default.createElement('defs', null, _react2.default.createElement('path', {
    id: 'a',
    d: 'M0 0h30v30H0z'
  })), _react2.default.createElement('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, _react2.default.createElement('mask', {
    id: 'b',
    fill: '#fff'
  }, _react2.default.createElement('use', {
    xlinkHref: '#a'
  })), _react2.default.createElement('path', {
    fill: '#FF4056',
    d: 'M10 8V7a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h4a1 1 0 0 1 0 2h-1v13a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V10H6a1 1 0 1 1 0-2h4zm2 0h6V7a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1zm9 2H9v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V10zm-9 4a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0v-6zm4 0a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0v-6z',
    mask: 'url(#b)'
  })));
};

RemoveIcon.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  width: '30',
  height: '30',
  viewBox: '0 0 30 30'
};

var Actions = function (_Component) {
  _inherits(Actions, _Component);

  function Actions() {
    _classCallCheck(this, Actions);

    return _possibleConstructorReturn(this, (Actions.__proto__ || Object.getPrototypeOf(Actions)).apply(this, arguments));
  }

  _createClass(Actions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cx = _props.cx,
          onMouseLeave = _props.onMouseLeave,
          handleRemove = _props.handleRemove,
          handleSetMain = _props.handleSetMain,
          isMainTile = _props.isMainTile;
      return _react2.default.createElement('div', {
        className: cx('root', {
          isMainTile: isMainTile
        }),
        onMouseLeave: onMouseLeave
      }, _react2.default.createElement('div', {
        className: cx('container')
      }, handleSetMain && _react2.default.createElement('span', {
        className: cx('icon', 'home'),
        onClick: handleSetMain
      }, _react2.default.createElement(HomeIcon, null), _react2.default.createElement('p', null, "Ustaw jako zdj\u0119cie podstawowe")), handleRemove && _react2.default.createElement('span', {
        className: cx('icon', 'remove'),
        onClick: handleRemove
      }, _react2.default.createElement(RemoveIcon, null), _react2.default.createElement('p', null, "Usu\u0144 zdj\u0119cie"))));
    }
  }]);

  return Actions;
}(_react.Component);

exports.default = (0, _reactHoc.withStyles)(_ActionsModule2.default)(Actions);
module.exports = exports.default;